// Sentiment comes from custom_attributes.sentiment (Russian list values set by
// RocketGPT) with additional_attributes.ai_markup.sentiment as a fallback.
const NORMALIZED = {
  позитивная: 'positive',
  нейтральная: 'neutral',
  негативная: 'negative',
  positive: 'positive',
  neutral: 'neutral',
  negative: 'negative',
};

export const SENTIMENT_STYLES = {
  positive: {
    icon: 'i-lucide-smile',
    label: 'MULTICHAT.SENTIMENT.POSITIVE',
    badgeClass: 'bg-n-teal-3 text-n-teal-11',
    barClass: 'bg-n-teal-9',
    textClass: 'text-n-teal-11',
  },
  neutral: {
    icon: 'i-lucide-meh',
    label: 'MULTICHAT.SENTIMENT.NEUTRAL',
    badgeClass: 'bg-n-alpha-2 text-n-slate-11',
    barClass: 'bg-n-slate-9',
    textClass: 'text-n-slate-11',
  },
  negative: {
    icon: 'i-lucide-frown',
    label: 'MULTICHAT.SENTIMENT.NEGATIVE',
    badgeClass: 'bg-n-ruby-3 text-n-ruby-11',
    barClass: 'bg-n-ruby-9',
    textClass: 'text-n-ruby-11',
  },
};

export const normalizeSentiment = value =>
  NORMALIZED[
    String(value || '')
      .trim()
      .toLowerCase()
  ] || null;

export const getConversationSentiment = conversation =>
  normalizeSentiment(conversation?.custom_attributes?.sentiment) ||
  normalizeSentiment(conversation?.additional_attributes?.ai_markup?.sentiment);
